import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSearchParams, useNavigate } from 'react-router-dom';
import WalletCover from '../../assets/target/images/WalletCover.png';
import AMLHistoryBlock from '../../components/AMLHistoryBlock';
import HistoryBlock from '../../components/HistoryBlock';
import AppConfig from '../../config';
import HelperService from '../../services/HelperService';
import { appSlice } from '../../store/slices';
import './Wallet.scss';
import AssetsBlock from './components/AssetsBlock';

const { routes } = AppConfig;

const Wallet = () => {
	const availableCurrencies = useSelector(store => store.app.availableCurrencies);

	const navigate = useNavigate();
	const dispatch = useDispatch();

	const walletBalance = availableCurrencies.reduce((acc, currency) => acc + currency.AmountUsd, 0);

	const onRowClick = row => {
		const list = [
			{ id: 1, title: 'Sanctions', volume: 0.19, amount: 28.4, color: 'orange' },
			{ id: 2, title: 'Illicit activity', volume: 0.34, amount: 21.9, color: 'orange' },
			{ id: 3, title: 'Mixers', volume: 1.45, amount: 17.255, color: 'orange' },
			{ id: 4, title: 'Gambling', volume: 3.1, amount: 1144200, color: 'orange' },
		];

		// dispatch(
		// 	appSlice.actions.addModal({
		// 		title: 'Test',
		// 		tag: 'AMLDetailsModal',
		// 		isOpen: true,
		// 		height: '80%',
		// 		outsideParams: { list },
		// 	})
		// );

		const mode = true;
		dispatch(
			appSlice.actions.addModal({
				isHeaderWithColorBgAndIcon: true,
				title: 'Freeze card',
				subtitle: 'Learn about freeze card',
				headerBackgroundColor: '#0455A3',
				headerIcon: 'SNOWFLAKE_SLASH_BOLD',
				tag: 'FreezeCard',
				headClass: 'FreezeCard',
				isOpen: true,
				height: '70%',
				outsideParams: { mode },
			})
		);
	};

	const deviceInfo = useSelector(state => state.app.deviceInfo);
	const osName = deviceInfo?.osName;

	const goToWalletInstruction = operationSystem => {
		navigate({
			pathname: routes.addCardToWallet,
			search: createSearchParams({ operationSystem: operationSystem }).toString(),
		});
	};

	const goToLimits = () => {
		navigate(routes.cardSpendingLimits);
	};

	// const renderButton = () => {
	// 	if (osName === 'iOS') {
	// 		return <button onClick={() => goToWalletInstruction('iOS')}>Add to Apple wallet</button>;
	// 	}
	// 	if (osName === 'Android') {
	// 		return <button onClick={() => goToWalletInstruction('Android')}>Add to Google wallet</button>;
	// 	}

	// 	return (
	// 		<>
	// 			<button onClick={() => goToWalletInstruction('iOS')}>Add to Apple wallet</button>
	// 			<button onClick={() => goToWalletInstruction('Android')}>Add to Google wallet</button>
	// 		</>
	// 	);
	// };

	const freezeCard = () => {
		dispatch(
			appSlice.actions.addModal({
				tag: 'FreezeCard',
			})
		);
	};

	const uploadFiles = () => {
		dispatch(
			appSlice.actions.addModal({
				isHeaderWithColorBgAndIcon: true,
				title: 'Upload file',
				subtitle: 'Maximum file size allowed: 10MB',
				headerBackgroundColor: '#0455A3',
				headerIcon: 'DOCUMENT_FILL',
				tag: 'TransactionFilesModal',
				isOpen: true,
				height: '70%',
			})
		);
	};


	return (
		<div className='Wallet'>
			{/* {renderButton()} */}
			{/* <button onClick={() => onRowClick()}>Freeze card</button>

			<button onClick={() => navigate(routes.openCard)}>Test open card</button>
			<button onClick={() => freezeCard()}>Test card 3</button>
			<button onClick={() => uploadFiles()}>Upload files</button> */}
			{/* {renderButton()} */}
			<img className='Wallet__background' src={WalletCover} alt='Wallet background' />
			<div className='Wallet__balance-block'>
				<div className='Wallet__balance-title'>Wallet</div>
				<div className='Wallet__balance'>$ {HelperService.FormatFiatWithoutCurrency(walletBalance)}</div>
			</div>

			{/* <button
				onClick={() =>
					navigate({ pathname: routes.addressAmlDetails, search: createSearchParams({ currencyId: 1 }).toString() })
				}
			>
				AML Details
			</button> */}

			<AssetsBlock />

			<HistoryBlock />

			<AMLHistoryBlock />
		</div>
	);
};

export default Wallet;
